import { PassValidityInterface, PassValidityIntervalEnum } from '../../..';

export class PassValidityDto implements PassValidityInterface {
  value: number;
  interval: PassValidityIntervalEnum;
}
